import {
  ProductCategory,
  ProductTypeLabel,
  VariationColorGroup,
} from 'src/modules/designStudio/helpers/productSelection/types';

export const ProductTypeNames: Record<ProductTypeLabel, string> = {
  [ProductTypeLabel.HORIZONTAL_SIDING]: 'Horizontal',
  [ProductTypeLabel.VERTICAL_SIDING]: 'Vertical',
  [ProductTypeLabel.SHINGLED_SIDING]: 'Shingles',
  [ProductTypeLabel.BRICK_SIDING]: 'Brick',
  [ProductTypeLabel.STONE_SIDING]: 'Stone',
  [ProductTypeLabel.CONCRETE_SIDING]: 'Concrete',
  [ProductTypeLabel.STUCCO_SIDING]: 'Stucco',
  [ProductTypeLabel.SHINGLE_ROOF]: 'Shingle',
  [ProductTypeLabel.TILE_ROOF]: 'Tile',
  [ProductTypeLabel.METAL_ROOF]: 'Metal',
  [ProductTypeLabel.TRIM]: 'Trim',
};

export const ProductTypesByCategory: Record<
  ProductCategory,
  ProductTypeLabel[]
> = {
  [ProductCategory.WALLS]: [
    ProductTypeLabel.HORIZONTAL_SIDING,
    ProductTypeLabel.VERTICAL_SIDING,
    ProductTypeLabel.SHINGLED_SIDING,
    ProductTypeLabel.BRICK_SIDING,
    ProductTypeLabel.STONE_SIDING,
    ProductTypeLabel.CONCRETE_SIDING,
    ProductTypeLabel.STUCCO_SIDING,
  ],
  [ProductCategory.ROOF]: [
    ProductTypeLabel.SHINGLE_ROOF,
    ProductTypeLabel.TILE_ROOF,
    ProductTypeLabel.METAL_ROOF,
  ],
  [ProductCategory.TRIM]: [ProductTypeLabel.TRIM],
};

export const ColorGroupNames: Record<VariationColorGroup, string> = {
  [VariationColorGroup.WHITE]: 'White',
  [VariationColorGroup.BEIGE]: 'Beige',
  [VariationColorGroup.GRAY]: 'Gray',
  [VariationColorGroup.BLACK]: 'Black',
  [VariationColorGroup.GREEN]: 'Green',
  [VariationColorGroup.BLUE]: 'Blue',
  [VariationColorGroup.YELLOW]: 'Yellow',
  [VariationColorGroup.RED]: 'Red',
  [VariationColorGroup.PURPLE]: 'Purple',
  [VariationColorGroup.PINK]: 'Pink',
  [VariationColorGroup.BROWN]: 'Brown',
};

export const ColorGroupDisplayHex: Record<VariationColorGroup, string> = {
  [VariationColorGroup.WHITE]: '#ffffff',
  [VariationColorGroup.BEIGE]: '#D6CDBA',
  [VariationColorGroup.GRAY]: '#8E9395',
  [VariationColorGroup.BLACK]: '#252728',
  [VariationColorGroup.GREEN]: '#4D6B5B',
  [VariationColorGroup.BLUE]: '#4D5B6B',
  [VariationColorGroup.YELLOW]: '#DBC68E',
  [VariationColorGroup.RED]: '#AF6161',
  [VariationColorGroup.PURPLE]: '#806398',
  [VariationColorGroup.PINK]: '#CC909F',
  [VariationColorGroup.BROWN]: '#957D6A',
};

export const ColorGroupMatchingHex: Record<VariationColorGroup, string> = {
  [VariationColorGroup.WHITE]: '#ffffff',
  [VariationColorGroup.BEIGE]: '#D6CDBA',
  [VariationColorGroup.GRAY]: '#838383',
  [VariationColorGroup.BLACK]: '#000000',
  [VariationColorGroup.GREEN]: '#00ff00',
  [VariationColorGroup.BLUE]: '#0000ff',
  [VariationColorGroup.YELLOW]: '#f5ff27',
  [VariationColorGroup.RED]: '#ff0000',
  [VariationColorGroup.PURPLE]: '#800080',
  [VariationColorGroup.PINK]: '#FFC0CB',
  [VariationColorGroup.BROWN]: '#654321',
};

export const ColorGroupRankings: Record<VariationColorGroup, number> = {
  [VariationColorGroup.WHITE]: 11,
  [VariationColorGroup.BEIGE]: 10,
  [VariationColorGroup.GRAY]: 9,
  [VariationColorGroup.BLACK]: 8,
  [VariationColorGroup.GREEN]: 7,
  [VariationColorGroup.BLUE]: 6,
  [VariationColorGroup.YELLOW]: 5,
  [VariationColorGroup.RED]: 4,
  [VariationColorGroup.PURPLE]: 3,
  [VariationColorGroup.PINK]: 2,
  [VariationColorGroup.BROWN]: 1,
};
